import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store'

const Page404 = resolve => require(['./pages/errors/Page404'], resolve)
const PageHome = resolve => require(['./pages/PageHome'], resolve)

const PageLogin = resolve => require(['./pages/auth/PageLogin'], resolve)
const PagePasswordReset = resolve => require(['./pages/auth/PagePasswordReset'], resolve)

const PageUseTerms = resolve => require(['./pages/PageUseTerms'], resolve)
const PagePrivacyPolicy = resolve => require(['./pages/PagePrivacyPolicy'], resolve)
const PageHowItWorks = resolve => require(['./pages/PageHowItWorks'], resolve)

// const PageLandingCompany = resolve => require(['./pages/PageLandingCompany'], resolve)
const PageCompanyRegistration = resolve => require(['./pages/PageCompanyRegistration'], resolve)

const PageSubcategory = resolve => require(['./pages/PageSubcategory'], resolve)
const PageProduct = resolve => require(['./pages/PageProduct'], resolve)
const PageSku = resolve => require(['./pages/PageSku'], resolve)
const PageSkuCheckout = resolve => require(['./pages/PageSkuCheckout'], resolve)
const PageMktpRentSent = resolve => require(['./pages/PageMktpRentSent'], resolve)

/*
const PageCompanies = resolve => require(['./pages/PageCompanies'], resolve)
const PageProfile = resolve => require(['./pages/PageProfile'], resolve)
const ProfileIndex = resolve => require(['./pages/children/profile/ProfileIndex'], resolve)
const ProfileData = resolve => require(['./pages/children/profile/ProfileData'], resolve)
const ProfileClientData = resolve => require(['./pages/children/profile/ProfileClientData'], resolve)
const ProfileReferences = resolve => require(['./pages/children/profile/ProfileReferences'], resolve)
const ProfileAddresses = resolve => require(['./pages/children/profile/ProfileAddresses'], resolve)
*/

const PageMyProfile = resolve => require(['./pages/PageMyProfile'], resolve)
const PageMyRents = resolve => require(['./pages/PageMyRents'], resolve)
const PageCancelAccount = resolve => require(['./pages/PageCancelAccount'], resolve)
const PageMyRentsDetails = resolve => require(['./pages/PageMyRentsDetails'], resolve)

const routes = [
  {path: '/', component: PageHome, name: 'home'},
  {path: '/:categorySlug/:subcategorySlug/:subcategoryId', component: PageSubcategory, name: 'subcategory'},
  {path: '/:categorySlug/:subcategorySlug/:productSlug/:productId', component: PageProduct, name: 'product'},
  {path: '/:categorySlug/:subcategorySlug/:productSlug/:skuSlug/:skuId', component: PageSku, name: 'sku'},
  {path: '/checkout', component: PageSkuCheckout, name: 'sku_checkout'},
  {path: '/locacao-enviada/:MktpRentId', component: PageMktpRentSent, name: 'mktp_rent_sent'},

  {path: '/login', component: PageLogin, name: 'login'},
  {path: '/password-reset', component: PagePasswordReset, name: 'password_reset'},
  {path: '/minha-conta', component: PageMyProfile, name: 'my_profile'},
  {path: '/termos-de-uso', component: PageUseTerms, name: 'use_terms'},
  {path: '/politicas-de-privacidade', component: PagePrivacyPolicy, name: 'privacy_policy'},
  {path: '/como-funciona', component: PageHowItWorks, name: 'how_it_works'},

  {path: '/cadastro-locadora', component: PageCompanyRegistration, name: 'company_registration'},
  {path: '/minhas-locacoes', component: PageMyRents, name: 'my_rents'},
  {path: '/cancelar-conta', component: PageCancelAccount, name: 'cancel_account'},
  {path: '/minhas-locacoes/:id', component: PageMyRentsDetails, name: 'my_rents_details'},
  // {path: '/quero-alugar-na-locashop', component: PageLandingCompany, name: 'company_landing_page'},
  // {path: '/quanto-custa', component: PagePricing, name: 'pricing'},
  // {path: '/locadoras', component: PageCompanies, name: 'companies'},
  /*
  { path: '/meus-dados',
    component: PageProfile,
    children: [
      {path: '', component: ProfileIndex, name: 'profile'},
      {path: 'dados', component: ProfileData, name: 'profile_data'},
      {path: 'dados-pf-pj', component: ProfileClientData, name: 'profile_client_data'},
      {path: 'referencias', component: ProfileReferences, name: 'profile_references'},
      {path: 'enderecos', component: ProfileAddresses, name: 'profile_addresses'}
    ]
  },
  */
  {path: '*', component: Page404, name: 'notfound'}
]

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  // Change the scroll of the parent to the original position
  if (from.name) window.parent.postMessage({scroll: true}, '*')
  // All authenticated routes needs to be putted on this array
  const requiresAuth = ['profile', 'rent', 'my_profile', 'my_rents', 'my_rents_details']
  // Check if the current route needs auth
  if (requiresAuth.includes(to.name)) {
    const user = store.state.user
    if (user && user.access_token) {
      next()
    } else {
      next({name: 'login', query: { redirect: to.fullPath }})
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router.js